import type { InstallerVerdict } from '@qim/shared'
import type { JSX } from 'react'

/**
 * The installer's own verdict on a run that applied and did not verify
 * (IM-186), as a headline.
 *
 * Above any Terraform error rather than beside it. On an exit 10 the last
 * Terraform error is "Kubernetes cluster unreachable: the server has asked for
 * the client to provide credentials" — true, and silent about what to do. On an
 * exit 11 there may be no Terraform error at all: the cause is a gateway route,
 * a migration job or a stuck release, and before this the panel fell back to
 * the generic message. The installer has already said which verification point
 * failed and why, so that is what leads.
 *
 * The reasons are printed as the installer wrote them. They are fixed strings
 * in the image, named `V1`…`V7` after its verification points, and a
 * paraphrase here would be a second vocabulary for whoever reads the log next.
 */
export const VerdictHeadline = ({
  verdict,
}: {
  readonly verdict: InstallerVerdict
}): JSX.Element => (
  <div className="failure-headline" role="alert">
    <strong>{verdict.summary}</strong>
    <ul className="verdict-reasons">
      {verdict.reasons.map((reason) => (
        <li key={reason}>{reason}</li>
      ))}
    </ul>
  </div>
)
